'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'jquery.mmenu';

// ----------------------------------------
// Private
// ----------------------------------------

let filters = $('#filters');
let $openBnt = $('#menu-open');
let $closeBtn = $('#menu-close');
let $openFiltersBnt = $('.mobile-filters-btn');
let $closeFiltersBtn = $('.mobile-btn');

let $toProfitBtn = $('.to-profit-calculator.index');

// ----------------------------------------
// Public
// ----------------------------------------

function mainMenu () {
	let $menu = $('#menu').mmenu({
		'slidingSubmenus': false,
		'extensions': [
			'pagedim-white',
			'position-right',
			'position-front',
			'border-none',

		],
		'navbar': {
			add: false
		}
	});

	let API = $menu.data('mmenu');

	$openBnt.on('click', function () {
		API.open();
	});

	$closeBtn.click(function () {
		API.close();
	});
}

function filtersMenu () {
	let $filters = filters.mmenu({
		'extensions': [
			'pagedim-black',
			'fx-menu-slide',
			'border-none',
			'theme-white'
		],
		'navbar': {
			add: false
		}
	});

	let API = $filters.data('mmenu');

	$openFiltersBnt.on('click', function () {
		API.open();
	});

	$closeFiltersBtn.click(function () {
		API.close();
	});
}

function scrollTo () {
	let API = $('#menu').data('mmenu');

	$toProfitBtn.on('click', function () {
		API.close();

		let target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 300
			}, 1000);
			return false;
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {mainMenu, filtersMenu, scrollTo};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/menu.js